export default __webpack_public_path__ + "static/media/gallery_00.4c46cf8a.jpg";